import { COUNTRY_SWEDEN_ID, COUNTRY_UAE_ID, URL_SWEDEN_PREFIX, URL_UAE_PREFIX } from "../data/constants"

class EditorRoute {
  static home() {
    return '/editor'
  }
  static editorialContentList() {
    return `${EditorRoute.home()}/editorial-content`
  }

  static editorialContentEdit(item){
    return `/editor/editorial-content/${item.id}`
  }

  static editorialContentCreate(){
    return `/editor/editorial-content/create`
  }

  static visualizeImageList() {
    return `${EditorRoute.home()}/visualize/images`
  }

  static visualizeImageEdit(item) {
    return `${EditorRoute.home()}/visualize/images/${item.id}`
  }

  static visualizeImageCreate() {
    return `${EditorRoute.home()}/visualize/images/create`
  }

  static visualizeVideoList() {
    return `${EditorRoute.home()}/visualize/videos`
  }

  static visualizeVideoEdit(item) {
    return `${EditorRoute.home()}/visualize/videos/${item.id}`
  }

  static visualizeVideoCreate() {
    return `${EditorRoute.home()}/visualize/videos/create`
  }

  static coreUserList() {
    return `${EditorRoute.home()}/core/users`
  }

  static coreUserDetail(item) {
    return `${EditorRoute.home()}/core/users/${item.id}`
  }

  static marketInstrumentList() {
    return `${EditorRoute.home()}/market/instruments`
  }

  static marketInstrumentDetail(item) {
    return `${EditorRoute.home()}/market/instruments/${item.id}`
  }

  static portfoliosPortfolioList() {
    return `${EditorRoute.home()}/portfolios/portfolios`
  }

  static portfoliosPortfolioDetail(item) {
    return `${EditorRoute.home()}/portfolios/portfolios/${item.id}`
  }

  static cacheList() {
    return `${EditorRoute.home()}/cache`
  }
}

class Route {
  static getCountrySlugFromId(countryId) {
    if (countryId == COUNTRY_SWEDEN_ID) {
      return URL_SWEDEN_PREFIX
    }
    return URL_UAE_PREFIX
  }

  static SVLandingPage() {
    return `/${URL_SWEDEN_PREFIX}`
  }
  static EditorialContentList(countryId) {
    if(countryId == COUNTRY_SWEDEN_ID) {
      return `/${URL_SWEDEN_PREFIX}/artiklar`
    } else if(countryId == COUNTRY_UAE_ID) {
      return `/${URL_UAE_PREFIX}/insights`
    }
  }

  static UAELandingPage() {
    return `/${URL_UAE_PREFIX}`
  }

  static UAEPortfolioList() {
    return `/${URL_UAE_PREFIX}/portfolios`
  }

  static UAEMarketADX() {
    return `/${URL_UAE_PREFIX}/instruments/markets/adx`
  }

  static UAEMarketDFM() {
    return `/${URL_UAE_PREFIX}/instruments/markets/dfm`
  }

  static UAEMarketNasdaqDubai() {
    return `/${URL_UAE_PREFIX}/instruments/markets/nasdaq-dxb`
  }

  static instrumentList(countryId = COUNTRY_UAE_ID) {
    if (countryId == COUNTRY_SWEDEN_ID) {
      return `/${URL_SWEDEN_PREFIX}/aktier`
    } else if (countryId == COUNTRY_UAE_ID) {
      return `/${URL_UAE_PREFIX}/instruments`
    }
  }

  static marketDetail(marketSlug) {
    return `/${URL_UAE_PREFIX}/instruments/markets/${marketSlug}`
  }

  static instrumentDetail(instrument) {
    const countryId = instrument.country_id
    if (countryId == COUNTRY_SWEDEN_ID) {
      return `/${URL_SWEDEN_PREFIX}/aktier/${instrument.slug}`
    } else {
      return `/${URL_UAE_PREFIX}/instruments/${instrument.slug}`
    }
  }

  static instrumentDetailInsights(instrument) {
    let suffix = 'insights'
    if (instrument.country_id == COUNTRY_SWEDEN_ID) {
      suffix = 'artiklar'
    }
    return `${this.instrumentDetail(instrument)}/${suffix}`
  }

  static instrumentDetailDisclosures(instrument) {
    let suffix = 'disclosures'
    if (instrument.country_id == COUNTRY_SWEDEN_ID) {
      suffix = 'nyheter'
    }
    const href = this.instrumentDetail(instrument)
    return `${href}/${suffix}`
  }

  static portfolioDetail(portfolio) {
    return `/${URL_UAE_PREFIX}/portfolios/${portfolio.identifier}/${portfolio.username}`
  }

  static portfolioDetailTransactions(portfolio) {
    return `${this.portfolioDetail(portfolio)}/transactions`
  }

  static portfolioDetailPositions(portfolio) {
    return `${this.portfolioDetail(portfolio)}/positions`
  }

  static threadsAll() {
    return `/${URL_UAE_PREFIX}/threads`
  }

  static threadsOnStocks() {
    return `/${URL_UAE_PREFIX}/threads/stocks`
  }

  static threadsOnPortfolios() {
    return `/${URL_UAE_PREFIX}/threads/portfolios`
  }

  static threadsOnDisclosures() {
    return `/${URL_UAE_PREFIX}/threads/disclosures`
  }

  static threadsOnTransactions() {
    return `/${URL_UAE_PREFIX}/threads/transactions`
  }

  static insightDetail(item) {
    if (item.instrument_identifier) {
      const root = this.instrumentDetailInsights({
        country_id: item.country_id, 
        ticker: item.instrument_ticker, 
        pk: item.instrument_identifier,
        slug: item.instrument_slug
      })
      return `${root}/${item.slug}`
    }
    let country = this.getCountrySlugFromId(item.country_id)
    if (item.country_id == COUNTRY_SWEDEN_ID) {
      return `/${country}/artiklar/${item.slug}`
    } else if (item.country_id == COUNTRY_UAE_ID) {
      return `/${country}/insights/${item.slug}`
    }
    return `/${country}/insights/${item.slug}`
  }

  static login(redirect) {
    if (redirect) {
      return `/authentication/login?next=${redirect}`
    }
    return `/authentication/login`
  }
  static loginRedirect(countryId) {
    if (countryId == COUNTRY_SWEDEN_ID) {
      return `/${URL_SWEDEN_PREFIX}`
    } else if (countryId == COUNTRY_UAE_ID) {
      return `/${URL_UAE_PREFIX}`
    }
    return `/${URL_UAE_PREFIX}`
  }

  static logout() {
    return `/authentication/logout`
  }

  static signup() {
    return `/authentication/create`
  }

  // DEPRECATED
  static SVInstrumentDetail(instrument) {
    return `/${URL_SWEDEN_PREFIX}/instruments/${instrument.name}/${instrument.isin}`
  }

  // DEPRECATED
  static SVPersonDetail(person) {
    return `/${URL_SWEDEN_PREFIX}/people/${person.first_name}${person.last_name}/${person.pk}/`
  }

}

export { Route, EditorRoute }